(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335],{

/***/ 35035:
/***/ (function(module) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),

/***/ 93269:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(57180);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var InputCheckbox = function(props) {
    var input = props.input, _meta = props.meta, touched = _meta.touched, error = _meta.error, visited = _meta.visited;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "flex ".concat(props.className ? props.className : "", " ").concat(props.disabled ? "disabled" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({}, input, {
                        type: "checkbox",
                        required: props.required,
                        disabled: props.disabled,
                        className: "checkbox-input opacity-0 w-0 h-0 ".concat(touched && error ? "error" : "")
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "checkbox-control flex-none w-5 h-5 p-1 mr-2 border-gray-light border rounded-4px bg-white ".concat(props.required ? "is-required" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            className: "",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            "aria-hidden": "true",
                            focusable: "false",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "3",
                                d: "M1.73 12.91l6.37 6.37L22.79 4.59"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "block Form-label label ".concat(props.spanClassName, " ").concat(props.required ? "is-required" : ""),
                        children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: props.label
                            }
                        }) : props.label
                    })
                ]
            }),
            props.required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: visited && error ? "" : "hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-red-brand text-sm",
                    children: error
                })
            })
        ]
    }));
};
InputCheckbox.defaultProps = {
    required: undefined,
    disabled: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = (InputCheckbox);


/***/ }),

/***/ 4792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Textarea = function(props) {
    var input = props.input, children = props.children, rows = props.rows, _meta = props.meta, touched = _meta.touched, error = _meta.error;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-between items-center",
                children: props.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                    htmlFor: props.id,
                    className: "Form-label ".concat(props.required ? "is-required" : "", " ").concat(props.disabled ? "disabled" : "", " ").concat(props.labelClass),
                    children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: props.label
                        },
                        className: "inline-block"
                    }) : props.label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", _objectSpread({}, input, {
                required: props.required,
                disabled: props.disabled,
                placeholder: props.placeholder,
                autoCorrect: props.autoCorrect,
                rows: rows,
                className: props.className ? "".concat(props.className, " ").concat(touched && error ? "error" : "") : "w-full text-black ".concat(props.inputClassName, " ").concat(touched && error ? "error" : ""),
                children: children
            })),
            touched && error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-red-brand text-sm",
                children: error
            })
        ]
    }));
};
Textarea.defaultProps = {
    id: undefined,
    label: undefined,
    required: undefined,
    disabled: undefined,
    placeholder: undefined,
    rows: undefined,
    autoCorrect: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = (Textarea);


/***/ }),

/***/ 5834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11752);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73510);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);





var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, _content = _publicRuntimeConfig.content, contactPhone = _content.phone, contactPhoneSecondary = _content.phoneSecondary, contactFax = _content.fax, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
var ContactsSidebar = function(param) {
    var cmsBlocks = param.cmsBlocks;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mb-12",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        as: "h3",
                        display: "h1",
                        title: "Call center",
                        classesProp: "mb-3"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "leading-none",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "block text-2xl text-black",
                                href: "tel:".concat(contactPhone),
                                children: contactPhone
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "block mt-1 leading-tight text-gray-text",
                                children: "Disponibil in toate retelele (tarif normal)"
                            })
                        ]
                    }),
                    !isBricoStore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "m-0 mt-3 leading-none",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "block text-2xl text-black",
                                href: "tel:".concat(contactPhoneSecondary),
                                children: contactPhoneSecondary
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "block mt-1 leading-tight text-gray-text",
                                children: "Apelabil din orice retea, din tara si din strainatate (tarif normal)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mb-12",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        as: "h3",
                        display: "h1",
                        title: "Program call center",
                        classesProp: "mb-3"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: cmsBlocks["contacts-serviciul-relatii-clienti"]
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mb-12",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        as: "h3",
                        display: "h1",
                        title: "Sediu central",
                        classesProp: "mb-3"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "my-3",
                        children: "Soseaua Bucuresti-Nord, Nr. 10, Corp O1, Voluntari, Judetul Ilfov"
                    }),
                    !isBricoStore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "m-0 mt-1",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                className: "font-bold",
                                children: "Fax:"
                            }),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: contactFax
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        as: "h3",
                        display: "h1",
                        title: "Vanzari corporate",
                        classesProp: "mb-3"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "m-0 mt-3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                href: "/vanzari-corporate/pag/",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "underline",
                                    children: "Contact"
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactsSidebar);


/***/ }),

/***/ 57180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./store/app/actions.js
var actions = __webpack_require__(27173);
// EXTERNAL MODULE: ./store/support/actions.js
var support_actions = __webpack_require__(3697);
// EXTERNAL MODULE: ./store/contacts/constants.js
var constants = __webpack_require__(25203);
// EXTERNAL MODULE: ./lib/api/helpers.js
var helpers = __webpack_require__(45963);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
;// CONCATENATED MODULE: ./store/contacts/actions.js



var getSubjects = function() {
    return function(dispatch, getState) {
        return (0,helpers/* makeApiCall */.Vo)({
            actions: {
                action: constants/* GET_CONTACTS_SUBJECTS */.jt,
                success: constants/* GET_CONTACTS_SUBJECTS_SUCCESS */.bA,
                fail: constants/* GET_CONTACTS_SUBJECTS_FAILURE */.CG
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            alert: false,
            alertMessage: "Get product couldn't be completed...",
            apiCall: api/* getContactsSubjectsApi */.N4n,
            apiArgs: [],
            formatResponse: function(response) {
                if (response === null || response === void 0 ? void 0 : response.data) {
                    var _data = response.data, _levels = _data.levels, max_levels = _levels.max_levels, fields = _levels.fields, types = _data.types;
                    if (fields && Object.keys(fields).length && (types === null || types === void 0 ? void 0 : types.length)) {
                        var fieldsFilteredByLevel = fields.reduce(function(fieldObj, field) {
                            var options = types.filter(function(type) {
                                return type.Level === field.level;
                            });
                            fieldObj[field.level] = {
                                level: field.level,
                                fieldName: field.field,
                                label: field.label,
                                options: options
                            };
                            return fieldObj;
                        }, {});
                        return {
                            fieldsFilteredByLevel: fieldsFilteredByLevel,
                            maxLevel: max_levels || fields.length
                        };
                    }
                }
            }
        });
    };
};
var sendIncident = function(values) {
    return function(dispatch, getState) {
        return (0,helpers/* makeApiCall */.Vo)({
            actions: {
                action: constants/* SEND_CONTACTS_INCIDENT */.ik,
                success: constants/* SEND_CONTACTS_INCIDENT_SUCCESS */.j1,
                fail: constants/* SEND_CONTACTS_INCIDENT_FAILURE */.Wd
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            alert: true,
            alertMessage: "Nu s-a putut trimite mesajul. Te rugam sa incerci din nou.",
            apiCall: api/* sendContactsIncidentApi */.YCl,
            apiArgs: [
                values
            ],
            formatResponse: function(response) {
                return response.data;
            },
            returnResponse: true
        });
    };
};

// EXTERNAL MODULE: ./components/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(94512);
// EXTERNAL MODULE: ./containers/Support/Layout.js + 1 modules
var Layout = __webpack_require__(72998);
// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
// EXTERNAL MODULE: ./containers/Contacts/Sidebar.js
var Sidebar = __webpack_require__(5834);
// EXTERNAL MODULE: ./lib/GTMHelper.js
var GTMHelper = __webpack_require__(17242);
// EXTERNAL MODULE: ./containers/ErrorPage.js
var ErrorPage = __webpack_require__(75720);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./node_modules/react-final-form-listeners/dist/react-final-form-listeners.es.js
var react_final_form_listeners_es = __webpack_require__(73337);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./lib/validations.js + 1 modules
var validations = __webpack_require__(38294);
// EXTERNAL MODULE: ./components/Loading.js
var Loading = __webpack_require__(24461);
// EXTERNAL MODULE: ./components/Form/InputText.js + 2 modules
var InputText = __webpack_require__(58833);
// EXTERNAL MODULE: ./components/Form/Checkbox.js
var Checkbox = __webpack_require__(71662);
// EXTERNAL MODULE: ./components/Form/Select.js
var Select = __webpack_require__(66569);
// EXTERNAL MODULE: ./components/Form/Textarea.js
var Textarea = __webpack_require__(4792);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
;// CONCATENATED MODULE: ./containers/Contacts/UserFields.js





var UserFields = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    component: InputText/* default */.Z,
                    id: "contact_full_name",
                    name: "Name",
                    label: "Nume Prenume",
                    required: true,
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isAlphaNumeric */.bJ)(), (0,validations/* hasMaxLength */.aG)(60))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    component: InputText/* default */.Z,
                    id: "contact_phone",
                    name: "Phone",
                    label: "Telefon",
                    type: "tel",
                    validate: (0,validations/* isPhoneNumber */.xT)()
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    component: InputText/* default */.Z,
                    id: "contact_email",
                    name: "Email",
                    label: "Introdu adresa de email",
                    type: "email",
                    required: true,
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isEmail */.Jh)(), (0,validations/* hasMaxLength */.aG)(80))
                })
            })
        ]
    });
};
/* harmony default export */ var Contacts_UserFields = (UserFields);

;// CONCATENATED MODULE: ./containers/Contacts/Success.js



function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var Success = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(Success, Component1);
    var _super = _createSuper(Success);
    function Success() {
        _classCallCheck(this, Success);
        return _super.apply(this, arguments);
    }
    _createClass(Success, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, contactPhone = _props.contactPhone, contactPhoneSecondary = _props.contactPhoneSecondary;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            title: "Solicitarea ta a fost inregistrata!",
                            as: "h3",
                            display: "h2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-3",
                            children: "Pentru mai multe detalii, verifica adresa de email."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Echipa Relatii Clienti."
                        }),
                        contactPhone && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "u-color-red",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                        children: "*"
                                    })
                                }),
                                "Daca in continuare ai nelamuriri, nu ezita sa ne contactezi la numarul de telefon:",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "tel:".concat(contactPhone),
                                    className: "inline-block",
                                    children: contactPhone
                                }),
                                contactPhoneSecondary && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        " ",
                                        "sau",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "tel:".concat(contactPhoneSecondary),
                                            className: "inline-block",
                                            children: contactPhoneSecondary
                                        })
                                    ]
                                }),
                                "."
                            ]
                        })
                    ]
                }));
            }
        }
    ]);
    return Success;
}(react.Component);
/* harmony default export */ var Contacts_Success = (Success);

;// CONCATENATED MODULE: ./containers/Contacts/Form.js




















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Form_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Form_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function Form_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function Form_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) Form_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) Form_defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Form_getPrototypeOf(o) {
    Form_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return Form_getPrototypeOf(o);
}
function Form_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Form_setPrototypeOf(subClass, superClass);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Form_possibleConstructorReturn(self, call) {
    if (call && (Form_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return Form_assertThisInitialized(self);
}
function Form_setPrototypeOf(o, p) {
    Form_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return Form_setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var Form_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function Form_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function Form_createSuper(Derived) {
    var hasNativeReflectConstruct = Form_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = Form_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = Form_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return Form_possibleConstructorReturn(this, result);
    };
}
var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, _settings = _publicRuntimeConfig.settings, websiteId = _settings.websiteId, websiteName = _settings.websiteName, baseUrl = _settings.baseUrl, _content = _publicRuntimeConfig.content, contactPhone = _content.phone, contactPhoneSecondary = _content.phoneSecondary;
var ContactForm = /*#__PURE__*/ function(Component1) {
    "use strict";
    Form_inherits(ContactForm, Component1);
    var _super = Form_createSuper(ContactForm);
    function ContactForm(props) {
        Form_classCallCheck(this, ContactForm);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(Form_assertThisInitialized(_this), "handleFileUpload", function(event) {
            // event.persist() should be used if we try to access event properties
            // in a asynchronous way.
            // By removing the following line, Safari doesn't fire the onChange event
            event.persist();
            if (event.target.files && event.target.files.length > 0) {
                var file = event.target.files[0];
                // Make new FileReader
                var reader = new FileReader();
                // Convert the file to base64 text
                reader.readAsDataURL(file);
                reader.onload = function() {
                    var base64FileContent = reader.result.split(",")[1];
                    var fileInfo = {
                        name: file.name,
                        type: file.type,
                        size: file.size / 1000000,
                        base64: base64FileContent
                    };
                    // Allow only certain MIME types
                    if (fileInfo.type !== "image/jpg" && fileInfo.type !== "image/jpeg" && fileInfo.type !== "image/png") {
                        // Alert user
                        _this.props.addAlert({
                            message: "Sunt permise doar fisiere de tipul JPEG, JPG si PNG",
                            variant: "warning"
                        });
                        // Reset input
                        _this.attachmentInput.current.value = "";
                    }
                    var fileSizeMax = 5;
                    // Allow only certain file sizes
                    if (fileInfo.size > fileSizeMax) {
                        // Alert user
                        _this.props.addAlert({
                            message: "Sunt permise doar fisiere mai mici de ".concat(fileSizeMax, "MB"),
                            variant: "warning"
                        });
                        // Reset input
                        _this.attachmentInput.current.value = "";
                    }
                    _this.setState({
                        attachment: fileInfo
                    });
                };
            } else {
                _this.setState({
                    attachment: null
                });
            }
        });
        var _this1 = Form_assertThisInitialized(_this);
        _defineProperty(Form_assertThisInitialized(_this), "handleFormSubmit", function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee(values) {
                var ref3, ref1, ref2, message, rest, customer, subject, attachments, formData, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            message = values.message, rest = _objectWithoutProperties(values, [
                                "message"
                            ]);
                            customer = _this1.props.customer;
                            subject = values.Message.split(" ").slice(0, 5).join(" ");
                            attachments = undefined;
                            if ((ref3 = _this1.state.attachment) === null || ref3 === void 0 ? void 0 : ref3.name) {
                                attachments = {
                                    Name: _this1.state.attachment.name,
                                    Type: _this1.state.attachment.type,
                                    Encoding: "base64",
                                    file: _this1.state.attachment.base64
                                };
                            }
                            formData = _objectSpread({
                                Subject: subject,
                                Message: message,
                                Attachments: attachments,
                                StoreId: websiteId,
                                StoreName: websiteName
                            }, ((ref1 = _this1.props.queryParams) === null || ref1 === void 0 ? void 0 : ref1.feedback) === "1" && {
                                origin: "store_feedback"
                            }, ((ref2 = _this1.props.queryParams) === null || ref2 === void 0 ? void 0 : ref2.store_name) && {
                                PhysicalStoreName: _this1.props.queryParams.store_name
                            }, rest);
                            _this1.setState({
                                isSending: true
                            });
                            _ctx.next = 10;
                            return _this1.props.onFormSubmit(formData);
                        case 10:
                            response = _ctx.sent;
                            if (response) {
                                _this1.setState({
                                    isSent: true,
                                    isSending: false,
                                    selectedLevels: {}
                                });
                                setTimeout(function() {
                                    _this1.formReset({
                                        fullName: customer && "".concat(customer.first_name, " ").concat(customer.last_name),
                                        phone: customer && customer.telephone,
                                        email: customer && customer.email
                                    });
                                }, 50);
                            } else {
                                _this1.setState({
                                    isSent: false,
                                    isSending: false
                                });
                            }
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }());
        _defineProperty(Form_assertThisInitialized(_this), "getOptionsForLevelByParentId", function(param) {
            var options = param.options, parentId = param.parentId;
            return options.filter(function(option) {
                return option.ParentSubjectId === parentId;
            });
        });
        _defineProperty(Form_assertThisInitialized(_this), "removeFormField", function(param, state, param1) {
            var _param = _slicedToArray(param, 1), name = _param[0], changeValue = param1.changeValue;
            changeValue(state, name, function() {
                return undefined;
            });
        });
        _defineProperty(Form_assertThisInitialized(_this), "handleFieldChange", function(param) {
            var form = param.form, level = param.level, value = param.value;
            var ref4;
            var formValues = form.getState().values;
            var _formSubjects = _this.props.formSubjects, fieldsFilteredByLevel = _formSubjects.fieldsFilteredByLevel, maxLevel = _formSubjects.maxLevel;
            var maxLevelName = (ref4 = fieldsFilteredByLevel[maxLevel]) === null || ref4 === void 0 ? void 0 : ref4.fieldName;
            var lastFieldWithValue = 1;
            // remove upper fields from form state if lower level is changed
            Object.values(fieldsFilteredByLevel).forEach(function(field) {
                if (field.level > level && formValues[field.fieldName]) {
                    form.mutators.removeFormField(field.fieldName);
                }
                if (formValues[field.fieldName]) {
                    lastFieldWithValue = field.level;
                }
            });
            // Rubbish but it works for now...
            if (!value && level < _this.state.lastVisibleField) {
                _this.setState({
                    lastVisibleField: level == 1 ? level : lastFieldWithValue + 1
                });
            } else if (value && level < maxLevel) {
                _this.setState({
                    lastVisibleField: level + 1
                });
            }
            if (formValues[maxLevelName]) {
                _this.setState({
                    showAdditionalDetailsField: true
                });
            } else if (_this.state.showAdditionalDetailsField) {
                //only change state if value is different
                _this.setState({
                    showAdditionalDetailsField: false
                });
            }
        });
        _this.state = {
            isSent: false,
            lastVisibleField: 1,
            attachment: undefined,
            showAdditionalDetailsField: false
        };
        _this.attachmentInput = /*#__PURE__*/ react.createRef();
        _this.formReset = undefined;
        return _this;
    }
    Form_createClass(ContactForm, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, customer = _props.customer, fieldsFilteredByLevel = _props.formSubjects.fieldsFilteredByLevel;
                var _state = this.state, isSending = _state.isSending, isSent = _state.isSent, lastVisibleField = _state.lastVisibleField, showAdditionalDetailsField = _state.showAdditionalDetailsField;
                if (!isSent) {
                    var _this3 = this;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                            onSubmit: this.handleFormSubmit,
                            mutators: {
                                removeFormField: this.removeFormField
                            },
                            initialValues: {
                                Name: customer && "".concat(customer.first_name, " ").concat(customer.last_name),
                                Phone: customer && customer.telephone,
                                Email: customer && customer.email
                            },
                            render: function(param2) {
                                var handleSubmit = param2.handleSubmit, form = param2.form, submitting = param2.submitting;
                                var _this2 = _this3;
                                _this3.formReset = form.reset;
                                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    onSubmit: handleSubmit,
                                    autoComplete: "false",
                                    noValidate: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Contacts_UserFields, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mb-5",
                                            children: "Raspunsul va fi comunicat in scris pe adresa de e-mail mentionata in cererea transmisa, in termen de maximum 15 zile de la data solicitarii tale."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            as: "h2",
                                            display: "h1",
                                            title: "Ai nevoie de suport legat de:",
                                            classesProp: "mb-3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                component: InputText/* default */.Z,
                                                id: "order_number",
                                                name: "OrderNo",
                                                label: "Numarul comenzii",
                                                type: "text",
                                                validate: (0,validations/* composeFormValidators */.JT)((0,validations/* hasMaxLength */.aG)(100))
                                            })
                                        }),
                                        Object.entries(fieldsFilteredByLevel).map(function(param) {
                                            var _param = _slicedToArray(param, 2), key = _param[0], ref6 = _param[1], fieldName = ref6.fieldName, label = ref6.label, options = ref6.options;
                                            var _this = _this2;
                                            var ref5;
                                            var level = Number(key);
                                            var prevFieldName = (ref5 = fieldsFilteredByLevel[level - 1]) === null || ref5 === void 0 ? void 0 : ref5.fieldName;
                                            var fieldOptions = level === 1 ? options : _this2.getOptionsForLevelByParentId({
                                                options: options,
                                                parentId: form.getState().values[prevFieldName]
                                            });
                                            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()("mb-4", {
                                                    hidden: level > lastVisibleField
                                                }),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_final_form_es/* Field */.gN, {
                                                        id: "Option-".concat(level),
                                                        name: fieldName,
                                                        component: Select/* default */.Z,
                                                        label: label,
                                                        required: true,
                                                        validate: (0,validations/* isRequired */.q9)(),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                                value: "",
                                                                children: [
                                                                    "Selectati ",
                                                                    label.toLowerCase()
                                                                ]
                                                            }),
                                                            fieldOptions.map(function(item) {
                                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                                    value: item.SubjectId,
                                                                    children: item.Title
                                                                }, item.SubjectId);
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_listeners_es/* OnChange */.GU, {
                                                        name: fieldName,
                                                        children: function(value) {
                                                            _this.handleFieldChange({
                                                                form: form,
                                                                level: level,
                                                                fieldName: fieldName,
                                                                value: value
                                                            });
                                                        }
                                                    })
                                                ]
                                            }, level));
                                        }),
                                        showAdditionalDetailsField && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mb-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                        component: Textarea/* default */.Z,
                                                        id: "message",
                                                        name: "Message",
                                                        required: true,
                                                        validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMaxLength */.aG)(1999)),
                                                        label: "Te rugam sa faci o scurta descriere a situatiei pentru care ai nevoie de ajutor:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mb-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "attachment",
                                                            className: "Form-label",
                                                            children: "Imagine"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            id: "attachment",
                                                            name: "attachment",
                                                            type: "file",
                                                            // iOS Safari 12 supports only image/* types
                                                            accept: "image/jpg,image/png,image/jpeg",
                                                            ref: _this3.attachmentInput,
                                                            onChange: _this3.handleFileUpload
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mb-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                        component: Checkbox/* default */.Z,
                                                        id: "terms_and_conditions",
                                                        name: "terms_and_conditions",
                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                "Sunt de acord cu",
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "".concat(baseUrl, "/suport-clienti/informatii-generale-termeni-si-conditii/"),
                                                                    title: "Termenii si conditiile",
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    className: "text-red-brand",
                                                                    children: "Termenii si conditiile"
                                                                }),
                                                                " ",
                                                                "de utilizare a site-ului ",
                                                                websiteName,
                                                                ".ro"
                                                            ]
                                                        }),
                                                        type: "checkbox",
                                                        required: true,
                                                        validate: (0,validations/* isRequired */.q9)()
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "mb-4",
                                                    children: [
                                                        "Informatie - Pentru informatii suplimentare, va rugam sa accesati pagina",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "".concat(baseUrl, "/protectia-datelor-caracter-personal/pag/"),
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                            children: "Protectia Datelor cu Caracter Personal"
                                                        }),
                                                        "."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "lg:w-1/2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        type: "submit",
                                                        disabled: submitting,
                                                        variant: "primary",
                                                        title: "Aplica",
                                                        display: "block"
                                                    })
                                                })
                                            ]
                                        }),
                                        isSending && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                                            height: 80,
                                            children: "Se trimite"
                                        })
                                    ]
                                }));
                            }
                        })
                    }));
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Contacts_Success, {
                    contactPhone: contactPhone,
                    contactPhoneSecondary: contactPhoneSecondary
                }));
            }
        }
    ]);
    return ContactForm;
}(react.Component);
/* harmony default export */ var Form = ((0,es/* connect */.$j)(function(state) {
    return {
        customer: state.user.customer,
        formSubjects: state.contacts.formSubjects
    };
}, {
    addAlert: actions/* addAlert */.V_
})(ContactForm));

;// CONCATENATED MODULE: ./pages/contact.js















function contact_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function contact_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function contact_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                contact_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                contact_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function contact_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function contact_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function contact_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) contact_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) contact_defineProperties(Constructor, staticProps);
    return Constructor;
}
function contact_getPrototypeOf(o) {
    contact_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return contact_getPrototypeOf(o);
}
function contact_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) contact_setPrototypeOf(subClass, superClass);
}
function contact_possibleConstructorReturn(self, call) {
    if (call && (contact_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return contact_assertThisInitialized(self);
}
function contact_setPrototypeOf(o, p) {
    contact_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return contact_setPrototypeOf(o, p);
}
var contact_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function contact_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function contact_createSuper(Derived) {
    var hasNativeReflectConstruct = contact_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = contact_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = contact_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return contact_possibleConstructorReturn(this, result);
    };
}
var SupportContactPage = /*#__PURE__*/ function(Component1) {
    "use strict";
    contact_inherits(SupportContactPage, Component1);
    var _super = contact_createSuper(SupportContactPage);
    function SupportContactPage() {
        contact_classCallCheck(this, SupportContactPage);
        return _super.apply(this, arguments);
    }
    contact_createClass(SupportContactPage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.query) {
                    (0,GTMHelper/* setGTMUtmInfo */.st)({
                        query: this.props.query
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: "Contacteaza-ne"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                            breadcrumbs: [
                                {
                                    id: 1,
                                    level: 2,
                                    name: "Suport clienti",
                                    url_key: "suport-clienti/"
                                },
                                {
                                    id: 1,
                                    level: 99,
                                    name: "Contact"
                                }, 
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                            categories: this.props.supportCategories,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                className: "lg:flex pt-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "lg:w-4/6 pb-6 lg:pb-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                as: "h1",
                                                display: "h1",
                                                title: "Date si formular de contact",
                                                classesProp: "mb-3"
                                            }),
                                            this.props.formSubjects ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Form, {
                                                queryParams: this.props.query,
                                                onFormSubmit: this.props.sendIncident
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {
                                                children: "Formularul de contact este indisponibil momentan."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "lg:w-2/6 pt-12 lg:pt-0 lg:pl-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar/* default */.Z, {
                                            cmsBlocks: this.props.cmsBlocks
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }));
            }
        }
    ]);
    return SupportContactPage;
}(react.Component);
SupportContactPage.getInitialProps = (function() {
    var _ref = contact_asyncToGenerator(runtime_default().mark(function _callee(ctx) {
        var reduxStore, query, categories, formSubjects, promises, pageCmsBlocksNames, cmsBlocksToRetrieve;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    reduxStore = ctx.reduxStore, query = ctx.query;
                    categories = reduxStore.getState().support.categories;
                    formSubjects = reduxStore.getState().contacts.formSubjects;
                    promises = [];
                    pageCmsBlocksNames = [
                        "contacts-serviciul-relatii-clienti",
                        "contacts-sediul-central",
                        "contacts-vanzari-corporate", 
                    ];
                    cmsBlocksToRetrieve = pageCmsBlocksNames.filter(function(cmsBlockName) {
                        return !reduxStore.getState().app.cmsBlocks[cmsBlockName];
                    });
                    if (cmsBlocksToRetrieve.length > 0) {
                        promises.push(reduxStore.dispatch((0,actions/* getCmsBlocks */.lD)(cmsBlocksToRetrieve)));
                    }
                    // Load data if misssing
                    !categories && promises.push(reduxStore.dispatch((0,support_actions/* getSupportCategories */.eU)()));
                    !formSubjects && promises.push(reduxStore.dispatch(getSubjects()));
                    _ctx.next = 11;
                    return Promise.all(promises);
                case 11:
                    if (!(Object.keys(query).length > 0)) {
                        _ctx.next = 13;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        query: query
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
})();
SupportContactPage.pageLayout = "default";
/* harmony default export */ var contact = ((0,es/* connect */.$j)(function(state) {
    return {
        formSubjects: state.contacts.formSubjects,
        cmsBlocks: state.app.cmsBlocks,
        supportCategories: state.support.categories
    };
}, {
    sendIncident: sendIncident
})(SupportContactPage));


/***/ }),

/***/ 73337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GU": function() { return /* binding */ OnChange; }
/* harmony export */ });
/* unused harmony exports ExternallyChanged, OnBlur, OnFocus */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66688);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var ExternallyChangedState =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ExternallyChangedState, _React$Component);

  function ExternallyChangedState(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      previous: props.input.value,
      externallyChanged: false
    };
    return _this;
  }

  var _proto = ExternallyChangedState.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props = this.props,
        value = _this$props.input.value,
        active = _this$props.meta.active;
    var previous = this.state.previous;

    if (value !== previous) {
      this.setState({
        previous: value,
        externallyChanged: !active
      });
    }
  };

  _proto.render = function render() {
    return this.props.children(this.state.externallyChanged);
  };

  return ExternallyChangedState;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

var ExternallyChanged = function ExternallyChanged(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return createElement(Field, {
    name: name,
    subscription: {
      active: true,
      value: true
    },
    allowNull: true,
    render: function render(props) {
      return createElement(ExternallyChangedState, _extends({}, props, {
        children: children
      }));
    }
  });
};

var OnBlurState =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(OnBlurState, _React$Component);

  function OnBlurState(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      previous: !!props.meta.active
    };
    return _this;
  }

  var _proto = OnBlurState.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props = this.props,
        children = _this$props.children,
        active = _this$props.meta.active;
    var previous = this.state.previous;

    if (previous && !active) {
      children();
    }

    if (previous !== active) {
      this.setState({
        previous: active
      });
    }
  };

  _proto.render = function render() {
    return null;
  };

  return OnBlurState;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

var OnBlur = function OnBlur(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return createElement(Field, {
    name: name,
    subscription: {
      active: true
    },
    render: function render(props) {
      return createElement(OnBlurState, _extends({}, props, {
        children: children
      }));
    }
  });
};

var OnChangeState =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(OnChangeState, _React$Component);

  function OnChangeState(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      previous: props.input.value
    };
    return _this;
  }

  var _proto = OnChangeState.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props = this.props,
        children = _this$props.children,
        value = _this$props.input.value;
    var previous = this.state.previous;

    if (value !== previous) {
      this.setState({
        previous: value
      });
      children(value, previous);
    }
  };

  _proto.render = function render() {
    return null;
  };

  return OnChangeState;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

var OnChange = function OnChange(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(react_final_form__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
    name: name,
    subscription: {
      value: true
    },
    allowNull: true,
    render: function render(props) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(OnChangeState, _extends({}, props, {
        children: children
      }));
    }
  });
};

var OnFocusState =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(OnFocusState, _React$Component);

  function OnFocusState(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      previous: !!props.meta.active
    };
    return _this;
  }

  var _proto = OnFocusState.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props = this.props,
        children = _this$props.children,
        active = _this$props.meta.active;
    var previous = this.state.previous;

    if (active && !previous) {
      this.setState({
        previous: active
      });
      children();
    } else if (!active && previous) {
      this.setState({
        previous: active
      });
    }
  };

  _proto.render = function render() {
    return null;
  };

  return OnFocusState;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

var OnFocus = function OnFocus(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return createElement(Field, {
    name: name,
    subscription: {
      active: true
    },
    render: function render(props) {
      return createElement(OnFocusState, _extends({}, props, {
        children: children
      }));
    }
  });
};




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1223,9774,2888,179], function() { return __webpack_exec__(93269); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);